// extracted by mini-css-extract-plugin
export default {"root":"register_root__h9CNt","title":"register_title__k7Q8Y","form":"register_form__we4UF","submitButton":"register_submitButton__Qhjaw"};